var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFullfiledWarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.707.293A.996.996 0 0014 0H6a.996.996 0 00-.707.293l-5 5A.996.996 0 000 6v8c0 .266.105.52.293.707l5 5A.997.997 0 006 20h8c.266 0 .52-.105.707-.293l5-5A.997.997 0 0020 14V6a.996.996 0 00-.293-.707l-5-5zM11 15H9v-2h2v2zm0-4H9V5h2v6z",
    fill: "#FFAC30"
  })));
}

export default SvgFullfiledWarningIcon;